import React, { DragEvent, useEffect, useState } from 'react'
import CouponConfigurableLabel from '../../../CouponConfigurableLabel'
import { Button, Chip } from '@mui/material'
import Dropzone from '../Dropzone'
import { convertFileToListOfData } from '../exclusionList/service';
import { resetInclusionData, updateInclusionData, saveInclusionFileUrl } from '../../../../../../stateManagement/actions/manageCouponActions';
import { isInclusionEmpty, validateXLSXFileType, uploadInclusionFile } from '../service';
import { openPopup } from '../../../../../../stateManagement/actions/popupActions';
import { labelMappings } from '../../../../utils/utils';
import { useCouponAlert } from '../../../../context/CouponAlert';
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from 'react-redux';
import CouponLoader from '../../../CouponLoader';
import { isLargeExclusion } from '../../../../services/services';


/**
 * This component is responsible for getting excel file input for outlet code inclusion
 * @returns 
 */

function InclusionList({ disable , disabledMessage}: { disable: boolean , disabledMessage?:string }) {
    const { showAlert } = useCouponAlert();
    const [incData, setIncData] = useState<{ file: File | null, list: Array<string> }>({ file: null, list: [] });
    const { list: inclusionList, file: inclusionFile } = useSelector((state: any) => state?.manageCoupons?.data?.inclusionData);
    const [isUploading, setIsUploading] = useState(false);
    const redux_inclusion_file_url = useSelector((state: any) => state?.manageCoupons?.data?.inclusionFileUrl);

    const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (disable) {
            showAlert(disabledMessage ?? labelMappings['INCLUSION_DISABLED'], 'warning');
            return;
        };
        const files = event?.target?.files;
        if (files && files[0]) {
            processFile(files[0]);
        }
    }
    const processFile = async (file: File) => {
        if (disable) {
            showAlert(disabledMessage ?? labelMappings['INCLUSION_DISABLED'], 'warning');
            return;
        };
        const data: string[] = await convertFileToListOfData(file);
        setIncData({file:file , list:data});
    }

    const handleFileRemove = () => {
        setIncData({file:null , list:[]});
        if(!isInclusionEmpty()){
            resetInclusionData();
            saveInclusionFileUrl("");
        }
        setIsUploading(false);
    }

    const handleDrop = async (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (disable) {
            showAlert(disabledMessage ?? labelMappings['INCLUSION_DISABLED'], 'warning');
            return;
        };
        const files = e?.dataTransfer.files;
        if (files && files[0]) {
            const res = await validateXLSXFileType(files[0]);
            if (res === false) {
                openPopup("Error", labelMappings["INVALID_FILE_INPUT"]);
                return;
            }
            processFile(files[0]);
        }
    }

    const handleSave = async () => {
        updateInclusionData(incData.list, incData.file);
        if(isLargeExclusion()) {
            try {
                setIsUploading(true);
                if (incData.file !== null) {
                    const inclusionFileUrl = await uploadInclusionFile(incData.file);
                    saveInclusionFileUrl(inclusionFileUrl);
                    console.log("inclusionFileUrl: " + inclusionFileUrl);
                    showAlert("File uploaded", 'success');
                }
            } catch (error) {
                showAlert("Failed to upload file", 'error');
            } finally {
                setIsUploading(false);
            }
        } else {
            showAlert("Data Saved", 'success');
        }
    }

    const checkUploadStatus = () => {
        return redux_inclusion_file_url === "" ? false : true;
    }    

    useEffect(() => {
        if (disable)
            handleFileRemove()
    }, [disable])

    useEffect(()=>{
        if(inclusionList.length > 0){
            setIncData({list : inclusionList , file:inclusionFile});
        }
    },[inclusionList,inclusionFile])

    return (
        <>
            <div className='exclusion-list-wrapper'>
                {
                    disable && <div
                        className="coupon-dashboard-disable-overlay"
                        onClick={() => showAlert(disabledMessage ?? labelMappings['INCLUSION_DISABLED'], 'info')} />
                }

                <div className="exclusion-list-header">
                    <CouponConfigurableLabel text='INCLUSION_LIST_HEADER' style={{ color: 'inherit' }} />
                </div>
                <div className="exclusion-list-content">
                    <Dropzone handleDrop={handleDrop} handleFileInput={handleFileInput} file={incData.file} handleFileRemove={handleFileRemove} />
                    {
                        incData.list && incData.list.length > 0 &&
                        <div className='exclusion-selected-outlet-code-wrapper'>
                            <div className='exclusion-selected-outlet-code'>
                            {isLargeExclusion() ? <></> :
                                <>
                                {
                                    incData.list.map((item: string) => {
                                        return <Chip label={item} key={`exlusion-${item}`} />
                                    })
                                }
                                </>
                            }
                            {/* 
                                {
                                    incData.list.map((item: string) => {
                                        return <Chip label={item} key={`exlusion-${item}`} />
                                    })
                                }
                            */}
                            </div> 
                            <div className='ex-in-save-btn-wrapper'>
                                {isLargeExclusion() ?
                                    <>
                                        {isUploading ? <CouponLoader /> :
                                            <Button variant='contained' className='inc-exc-save-btn' size='small' startIcon={<DoneIcon />} onClick={handleSave} disabled={checkUploadStatus()}>Save</Button>
                                        }
                                    </> :
                                    <>
                                        <Button variant='contained' className='inc-exc-save-btn' size='small' startIcon={<DoneIcon />} onClick={handleSave}>Save</Button>
                                    </>
                                }                      
                            </div>
                        </div>
                    }
                </div>
                
               
            </div>
        </>
    )
}

export default InclusionList